import theme from 'style/theme';
import styled from 'styled-components';

export const BoldText = styled.span`
  font-weight: ${theme.fonts.weight.bold};
`;
